<script lang="ts">import { beforeNavigate } from "$app/navigation";
import { getGameTabs } from "./tabCategories";
import { GameCategory, GameSort } from "@infinitro/catalog-min";
import { ReleaseStage, stateFeatureSet, stateTheme, stateUi, wantAtLeastReleaseStage } from "@infinitro/config";
import { isAndroid, locale, loggedIn, ModalDialog, scrollPosition, searchModalPreselectedTab, shouldScrollToTop, stateOpenModal } from "@infinitro/global";
import { SearchInput } from "@infinitro/sidebar";
import { Tabs, TabsButtons } from "@infinitro/tabs";
import { onDestroy } from "svelte";
import { get } from "svelte/store";
const theme = get(stateTheme);
export let searchQuery = "";
export let activeTab = GameCategory.All;
export let selectedSortBy = activeTab === GameCategory.NewGames ? GameSort.Newest : GameSort.Popular;
export let selectedProvider = undefined;
export let providers = [];
let tabCategoryItem;
const openSearchModal = () => {
	searchModalPreselectedTab.set(activeTab);
	stateOpenModal.set(ModalDialog.Search);
};
const optionsTab$ = getGameTabs(theme, locale, loggedIn, stateFeatureSet);
const saveScrollPosition = (position) => {
	scrollPosition.set(position);
};
beforeNavigate(() => {
	shouldScrollToTop.set(false);
});
onDestroy(() => {
	shouldScrollToTop.set(true);
});
$: {
	activeTab;
	console.log(`activeTab: ${activeTab}`);
	selectedSortBy = activeTab === GameCategory.NewGames ? GameSort.Newest : GameSort.Popular;
}
$: useDefault = $stateUi.tabs.tabsStyle === "default";
$: useAlternative = $stateUi.tabs.tabsStyle === "alternative";
$: useAlternative2 = $stateUi.tabs.tabsStyle === "alternative2";
$: useAlternative4 = $stateUi.tabs.tabsStyle === "alternative4";
</script>

<div
	class="toolbar"
	class:alternative-toolbar={useAlternative || useAlternative4}
	class:alternative-toolbar-2={useAlternative2}
>
	<div
		class:search-button-container-alternative-2={useAlternative2}
		class:search-button-container-alternative={!useDefault}
		class:search-button-container={useDefault}
		class:custom-margin-top={$isAndroid && useDefault}
	>
		<SearchInput {openSearchModal} isButtonMode={true} isOnToolbar={true} />
	</div>
	<div
		class="toolbar-tabs"
		class:toolbar-tabs-default={useDefault}
		class:toolbar-tabs-alternative2={useAlternative2}
	>
		<div
			class="tabs {useAlternative || useAlternative4 ? 'alternative-tabs' : ''} category-item"
			bind:this={tabCategoryItem}
		>
			{#if useAlternative || useAlternative4}
				<TabsButtons
					tabs={$optionsTab$}
					{activeTab}
					size="small-tab"
					preserveScrollPosition
					{saveScrollPosition}
				/>
			{:else}
				<Tabs
					tabs={$optionsTab$}
					{activeTab}
					preserveScrollPosition
					{saveScrollPosition}
					notSameSize={wantAtLeastReleaseStage(ReleaseStage.Alpha)}
					customClass="tab-category-tabs {!$loggedIn ? 'full-width-tabs-container' : ''}"
					width="fit-content"
				/>
			{/if}
		</div>
	</div>
	<!--
  <div class="toolbar-inputs-container">
    <div class="toolbar-search-input">
      <Input
        icon={SearchIcon}
        placeholder={`${$t(Verbiage.search)} ${$optionsTab$.find((tab) => tab.value === activeTab)?.label || ''}`}
        bind:value={searchQuery}
      />
    </div>
    {#if (!hideProviderCategories.includes(activeTab) && providerOptions?.length > 0) || !hideSortCategories.includes(activeTab)}
      <div class="toolbar-dropdown-items">
        {#if !hideProviderCategories.includes(activeTab) && providerOptions?.length > 0}
          <div class="toolbar-dropdown-item">
            <Dropdown
              width="100%"
              placeholder={$t(Verbiage.providers)}
              options={providerOptions}
              bind:value={selectedProvider}
            />
          </div>
        {/if}
        {#if !hideSortCategories.includes(activeTab)}
          <div class="toolbar-dropdown-item">
            <Dropdown
              width="100%"
              placeholder={$t(Verbiage.sort_by)}
              options={sortByOptions}
              bind:value={selectedSortBy}
            />
          </div>
        {/if}
      </div>
    {/if}
  </div>
  -->
</div>

<style>
	:global(.tab-category-tabs p) {
		white-space: nowrap;
}

	:global(.tab-category-tabs) {
		min-width: 100%;
}

	:global(.full-width-tabs-container) {
		min-width: 100%;
}

	.toolbar {
		margin-bottom: 1rem;
		display: flex;
		width: 105%;
		-webkit-mask-image: linear-gradient(to right, black 0%, black 92%, transparent 98%);
		mask-image: linear-gradient(to right, black 0%, black 92%, transparent 98%);
		-webkit-mask-repeat: no-repeat;
		mask-repeat: no-repeat;
}

	@media (min-width: 1024px) {
		.toolbar {
				width: 100%;
				align-items: flex-start;
			-webkit-mask-image: none;
			mask-image: none;
		}
	}

	.alternative-toolbar {
		mask-image: none;
		-webkit-mask-image: none;
	}

	.alternative-toolbar-2 {
		align-items: flex-start;
}

	.search-button-container-alternative {
		height: 40px;
		width: 40px;
		min-width: 40px;
}

	.search-button-container-alternative-2 {
		position: relative;
		top: 4px;
		height: 40px;
		width: 40px;
		min-width: 40px;
}

	.search-button-container {
		margin-top: 4px;
		height: 40px;
		width: 40px;
		min-width: 40px;
}

	.custom-margin-top {
		margin-top: -7px;
}

	@media (min-width: 1024px) {
		.search-button-container {
				margin-top: 0px;
				height: 40px;
				width: 40px;
				min-width: 40px;
		}
	}

	.toolbar-tabs {
		margin-left: .5rem;
		display: flex;
		width: 100%;
		gap: 0.5rem;
		overflow-y: hidden;
		overflow-x: scroll;
		padding-bottom: 0.25rem;
}

	@media (max-width: 1023px) {
		.toolbar-tabs {
			width: calc(100% + 8vw);
		}
	}

	.toolbar-tabs::-webkit-scrollbar {
		height: 4px;
		background-color: transparent;
}

	.toolbar-tabs::-webkit-scrollbar-track {
		background-color: transparent;
}

	.toolbar-tabs::-webkit-scrollbar-thumb {
		border-radius: 0.5rem;
		background-color: transparent;
}

	.toolbar-tabs-default::-webkit-scrollbar {
		height: 4px;
}

	.toolbar-tabs-default::-webkit-scrollbar-track {
		background-color: transparent;
}

	.toolbar-tabs-default::-webkit-scrollbar-thumb {
		border-radius: 9999px;
		background-color: var(--color-secondary-500);
}

	.toolbar-tabs-alternative2::-webkit-scrollbar {
		height: 4px;
}

	.toolbar-tabs-alternative2::-webkit-scrollbar-track {
		background-color: transparent;
}

	.toolbar-tabs-alternative2::-webkit-scrollbar-thumb {
		border-radius: 9999px;
		background-color: var(--color-neutral-300);
}

	.tabs {
		width: 100%;
		min-width: 1100px;
}

	@media (min-width: 1280px) {
		.tabs {
				min-width: 0px;
		}
	}

	.alternative-tabs {
		width: 100%;
		min-width: 0px;
}

	.toolbar-inputs-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		justify-content: space-between;
		gap: 1rem;
}

	@media (min-width: 1024px) {

		.toolbar-inputs-container {
				flex-direction: row;
		}
}

	.toolbar-search-input {
		width: 100%;
}

	.toolbar-dropdown-items {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
}

	@media (min-width: 1024px) {

		.toolbar-dropdown-items {
				width: 40%;
		}
}

	.toolbar-dropdown-item {
		width: 100%;
}
</style>
